import type { ReactNode } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';

export type SubPageRoute = { path: string; element: ReactNode };

/**
 * Routes a page's sub-pages without the tab row the stock page draws over
 * them. The page root redirects to the first sub-page, as the stock page does.
 */
export const SubPageRoutes = ({ pages }: { pages: SubPageRoute[] }) => (
  <Routes>
    {pages.length > 0 ? (
      <Route index element={<Navigate to={pages[0].path} replace />} />
    ) : null}
    {pages.map(({ path, element }) => (
      <Route key={path} path={`${path}/*`} element={element} />
    ))}
  </Routes>
);
